// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-11-26 23:39:08 +0100 (Wed, 26 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158676 $
//  Purpose   : uix admin parts
// =============================================================================
export const parts = true;
export const nodemenu = true;
export const dashpanels = true;
import * as views from './views';
export { views };
